// @ts-nocheck
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import getColor from "@insite/mobius/utilities/getColor";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

Object.assign(priceStyles, {
    productPrice: {
        wrapper: {
            css: css`
                ${x => spacingStyles(x.theme.design.product.detail.contentSpacing, null)}
            `,
        },
        priceWrapper: {
            css: css`
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                color: ${getColor("primary")};
            `,
        },
        price: {
            priceText: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.big};
                    font-weight: ${x => x.theme.design.typography.weight.medium};
                `,
            },
            unitOfMeasureText: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.large};
                    line-height: ${x => x.theme.design.typography.lineHeight.larger};
                `,
            },
        },
    },
});
